const formatCurrency = (number, isFraction = false) => {
    const config = {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0,
        maximumFractionDigits: isFraction ? 2 : 0,
    };
    return new Intl.NumberFormat('ru-RU', config).format(number);
};

export { formatCurrency };
//# sourceMappingURL=formatCurrency.js.map
